import { CircularProgress } from '@mui/material';
import { Alert } from 'api/alerts/alerts.types';
import { format } from 'date-fns';
import parse, {
  HTMLReactParserOptions,
  Element,
  domToReact,
} from 'html-react-parser';
import * as S from './Notifications.css';
import { NotificationLink } from './Notifications.css';

interface Props {
  notification: Alert;
  handleDelete: (id: number) => void;
  isDeleting?: boolean;
}

const parserOptions: HTMLReactParserOptions = {
  replace: (domNode) => {
    if (domNode instanceof Element && domNode.attribs) {
      if (domNode.type === 'tag' && domNode.attribs.href) {
        return (
          <NotificationLink to={domNode.attribs.href.replace('#', '')}>
            {domToReact(domNode.children, parserOptions)}
          </NotificationLink>
        );
      }
    }
  },
};

export const Notification = ({
  notification,
  handleDelete,
  isDeleting,
}: Props) => (
  <S.NotificationAlert
    severity='info'
    sx={{ opacity: isDeleting ? 0.6 : 1, transition: 'opacity 0.2s' }}
    action={
      isDeleting ? (
        <CircularProgress size={18} color='inherit' sx={{ mt: '2px' }} />
      ) : undefined
    }
    onClose={isDeleting ? undefined : () => handleDelete(notification.id)}
  >
    <S.NotificationDate>
      {format(notification.date, 'MM/dd/yyyy')}
    </S.NotificationDate>
    {parse(notification.message, parserOptions)}
  </S.NotificationAlert>
);
